import { ExternalLinkIcon } from "@radix-ui/react-icons";
import { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";

const ExternalLinkWrapper = ({ children }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const links = contentRef.current.querySelectorAll("a");
      links.forEach((link) => {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");

        if (!link.nextSibling?.classList?.contains("external-icon")) {
          const wrapper = document.createElement("span");
          wrapper.style.display = "inline-flex";
          wrapper.style.alignItems = "baseline";
          wrapper.style.gap = "4px";

          link.replaceWith(wrapper);
          wrapper.appendChild(link);

          const iconContainer = document.createElement("span");
          iconContainer.classList.add("external-icon");
          wrapper.appendChild(iconContainer);

          createRoot(iconContainer).render(
            <ExternalLinkIcon className="inline-block" />
          );
        }
      });
    }
  }, [children]);

  return <div
    className="[&_a]:text-blue-600 [&_a:hover]:underline [&_svg]:text-blue-600"
    ref={contentRef}>
    {children}
  </div>;
};

export default ExternalLinkWrapper;
